import React, {useState, useEffect, useContext} from 'react';
// import logo from '../logo.svg';
import './App.css';

import { userActions, alertActions } from '../_actions';

import { connect } from 'react-redux';
import { Router, Route, HashRouter, Redirect } from 'react-router-dom';
// import styled, {css} from 'styled-components';
import { LoginPage } from '../LoginPage';
import { history } from '../_helpers';
import { userConstants } from '../_constants';
import {PrivateRoute} from '../_components/PrivateRoute'

import Home from '../Components/Home/Home'
import Nav from '../Components/Nav/Nav';
import Profile from '../Components/Profile/Profile'
// import Admin from '../Admin/Admin'
// import AdminNav from '../Admin/AdminNav/AdminNav'
// import AdminFile from '../Admin/AdminFile/AdminFile';
// import AdminNotice from '../Admin/AdminNotice/AdminNotice';
// import AdminDock from '../Admin/AdminDock/AdminDock';

// import PropTypes, {InferProps} from 'prop-types'
import SignIn from '../Components/SignIn/SignIn';
import { UserContext } from '../context/context';
import ComNav from '../Components/Nav/ComNav';
import ComSignIn from '../Components/SignIn/ComSignIn';
import ComProfile from '../Components/Profile/ComProfile';
// import Modal from '../Components/Nav/Modal';
// import useModal from '../Components/Nav/useModal'
import ComRa from '../Components/Ralist/ComRa';
import ComSingleRa from '../Components/Ralist/ComSingleRa';
import ComAddRa from '../Components/Ralist/ComAddRa';
import Ralist from '../Components/Ralist/Ralist';
import SingleRa from '../Components/Ralist/SingleRa';
import ComHome from '../Components/Home/ComHome';
import ComRaboard from '../Components/Ralist/ComRaboard';
import ComSearch from '../Components/Search/ComSearch';
import ComRaboardDetail from '../Components/Ralist/ComRaboardDetail';
import ComSingleSearch from '../Components/Search/ComSingleSearch'
import ApplyHistory from '../Components/Profile/ApplyHistory';
// import ProposalHistory from '../Components/Profile/ProposalHistory';
import Message from '../Components/Message/Message';
import ComUserpost from '../Components/Profile/ComUserpost';
import ComCompanyinfo from '../Components/Profile/ComCompanyinfo';
import ComRaSearch from '../Components/Ralist/ComRaSearch';
import Quration from '../Components/Quration/Quration';
import QurationWrite from '../Components/Quration/QurationWrite';
import QurationSingle from '../Components/Quration/QurationSingle';
import Resume from '../Components/Resume/Resume';
import ResumeSingle from '../Components/Resume/ResumeSingle';
// import ResumeAdd from '../Components/Resume/ResumeAdd';
import Report from '../Components/Report/Report';
import ReportSingle from '../Components/Report/ReportSingle';
import ReportWrite from '../Components/Report/ReportWrite';
import ComInfoPost from '../Components/Info/ComInfoPost';
import CompanyInfoView from '../Components/Ralist/CompanyInfoView';
import Verify from '../Components/Confirm/Verify';
import {Confirm}  from '../Components/Confirm';
import ComRaSingleUser from '../Components/Search/ComRaSingleUser'



function App() {
  // const [state, setState] = useState(false);
  // const [width, setWidth] = useState(window.innerWidth);
  const [state, actions] = useContext(UserContext);
  // const {isShowing, setIsShowing} = useModal(true);

  console.log(state)

  useEffect(() => {
    if (!localStorage.getItem('email') && !localStorage.getItem('user') && !state.token && !state.user){
      console.log(" log out ")
      actions.setToken(null)
      actions.setUser(null)
      userActions.logout()
    }
    else if(localStorage.getItem('user')){
      // let user = JSON.parse(String(localStorage.getItem('user')))
      // actions.setToken(user.token)
      // actions.setUser(user)
      // console.log("App에서 토큰")
    }


    // else if(localStorage.getItem('user')){
    //   let user = JSON.parse(String(localStorage.getItem('user')))
    //   // console.log(state)
    //   // console.log(user)
    //   // console.log(user.token)
    //   actions.setToken(user.token)
    //   actions.setUser(user)

    //   // localStorage.clear()


    // }

    // const handleWindowResize = () => setWidth(window.innerWidth)
    // window.addEventListener("resize", handleWindowResize);
    // // console.log(width)

    // return () => window.removeEventListener("resize", handleWindowResize);
  })

  // constructor(props:any){
  //   super(props)
  // }

  // static propTypes = {
  //   logged_in: PropTypes.bool.isRequired,
  //   display_form: PropTypes.func.isRequired,
  //   handle_logout: PropTypes.func.isRequired
  // };

//   componentWillMount() {
//     // debugger
//     // this.props.getUsers();
//     // console.log(this.props.getUsers())
//     history.listen((location, action) => {
//         // clear alert on location change
//         this.props.clearAlerts();
//     });
//     // window.removeEventListener('scroll', this._handleScroll);

//     // localStorage.setItem('username')
// }

  
  // componentDidMount(){
    
  // }

  function handle_logout(){
    console.log("YOU")
    // this.props.clearAlerts();
    // console.log(this.display_form)
    // localStorage.clear();
    
    userActions.logout()



    actions.setIsShowing(false)
    // window.location.reload()
    return { type: userConstants.LOGOUT };
  }

    // console.log(this.props.logout)
  return (
    
    <div className="App">

      {window.location.protocol==="http:" || window.location.protocol==="https:" ? 
        <Router history={history}>
          
          <Route exact path='/' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/' component={Home}/>

          <Route exact path='/quration' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration' render={(props)=><Quration/>}/>

          <Route exact path='/quration/:field' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration/:field' render={(props)=><Quration/>}/>
          
          {/* <Route exact path='/quration/:field/:field' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration/:field/:field' render={(props)=><Quration/>}/> */}

          <Route exact path='/quration/single/:id' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration/single/:id' render={(props)=><QurationSingle/>}/>

          <Route exact path='/quration/edit' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration/edit' render={(props)=><QurationWrite/>}/>
          <Route exact path='/quration/edit/:id' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/quration/edit/:id' render={(props)=><QurationWrite/>}/>

          
          <Route exact path='/messages' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/messages' render={(props)=><Message/>}/>

          <Route exact path='/ralist' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/ralist' render={(props)=><Ralist/>}/>

          <Route exact path='/ralist/:field' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/ralist/:field' render={(props)=><Ralist/>}/>

          <Route exact path='/ralist/:field/:job' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/ralist/:field/:job' render={(props)=><Ralist/>}/>

          <Route exact path='/ralist/single/:id/:title' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/ralist/single/:id/:title' render={(props)=><SingleRa/>}/>

          <Route exact path='/resume' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/resume' render={(props)=><Resume/>}/>
          <Route exact path='/resume/edit/:id' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/resume/edit/:id' render={(props)=><ResumeSingle/>}/>
          {/* <Route exact path='/resume/add' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/resume/add' render={(props)=><ResumeAdd/>}/> */}

          <Route exact path='/event' render={(props)=><Nav logout={handle_logout}/>}/>
          
          <Route exact path='/companynlab' render={(props)=><Nav logout={handle_logout}/>}/>

          <Route exact path='/companynlab/:id' render={(props)=><Nav logout={handle_logout}/>}/>
          <Route exact path='/companynlab/:id' render={(props)=><CompanyInfoView/>}/>

          
          <Route path='/profile' render={(props)=><Nav logout={handle_logout}/>}/>
          <PrivateRoute path='/profile' component={Profile}/>

          <Route path='/applylist' render={(props)=><Nav logout={handle_logout}/>}/>
          <PrivateRoute path='/applylist' component={ApplyHistory}/>

          <Route path='/proposallist' render={(props)=><Nav logout={handle_logout}/>}/>
          <PrivateRoute path='/proposallist' component={ApplyHistory}/>
          
          
          <Route exact path='/signIn' render={(props)=><SignIn token={state.token} />}/>
          
          <Route exact path='/recruiter' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter' render={(props)=><ComHome />}/>
    
          <Route exact path='/recruiter/profile' render={(props)=><ComNav logout={handle_logout}/>}/>
          <PrivateRoute exact path='/recruiter/profile' component={ComProfile}/>
          

          <Route exact path='/recruiter/signIn' render={(props)=><ComSignIn />}/>
{/* 
          <Route exact path='/recruiter/ra' render={(props)=>{localStorage.getItem('user') ? <ComRa /> : 
            <ComRa />
          
            }}/> */}

          <Route exact path='/recruiter/raboard' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/raboard' render={(props)=><ComRaboard/>}/>

          <Route exact path='/recruiter/raboard/:id/:status' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/raboard/:id/:status' render={(props)=><ComRaboard/>}/>
          {/* <Route exact path='/recruiter/raboard' render={(props)=><ComRaboardDetail/>}/> */}
          <Route exact path='/recruiter/raboard/:id/:status' render={(props)=><ComRaboardDetail/>}/>

          <Route path='/recruiter/singleuser/:id' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route path='/recruiter/singleuser/:id' render={(props)=><ComRaSingleUser/>}/>


          <Route exact path='/recruiter/search' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/search' render={(props)=><ComSearch/>}/>
          <Route exact path='/recruiter/search/:field' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/search/:field' render={(props)=><ComSearch/>}/>
          <Route exact path='/recruiter/search/:field/:job' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/search/:field/:job' render={(props)=><ComSearch/>}/>

          <Route path='/recruiter/singlesearch/:id' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route path='/recruiter/singlesearch/:id' render={(props)=><ComSingleSearch/>}/>
          
          

          <Route exact path='/recruiter/ra' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/ra' render={(props)=><ComRa/>}/>
          

          <Route exact path='/recruiter/ra/:id/:title' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/ra/:id/:title' render={(props)=><ComSingleRa/>}/>

          <Route exact path='/recruiter/ra/:id/:title/:which' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/ra/:id/:title/:which' render={(props)=><ComSingleRa/>}/>

          <Route exact path='/recruiter/raadd' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/raadd' render={(props)=><ComAddRa/>}/>
          
          <Route exact path='/recruiter/raedit/:id' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/raedit/:id' render={(props)=><ComAddRa/>}/>

          <Route exact path='/recruiter/messages' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/messages' render={(props)=><Message/>}/>

          <Route exact path='/recruiter/companyinfo' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/companyinfo' render={(props)=><ComInfoPost/>}/>

          <Route exact path='/recruiter/companyinfo/edit' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/companyinfo/edit' render={(props)=><ComInfoPost/>}/>

          <Route exact path='/recruiter/userpost' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/userpost' render={(props)=><ComUserpost/>}/>
          
          <Route exact path='/recruiter/rasearch' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/rasearch' render={(props)=><ComRaSearch/>}/>
          <Route exact path='/recruiter/rasearch/:field' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/rasearch/:field' render={(props)=><ComRaSearch/>}/>
          <Route exact path='/recruiter/rasearch/:field/:job' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/rasearch/:field/:job' render={(props)=><ComRaSearch/>}/>
          
          <Route exact path='/recruiter/companypost' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/companypost' render={(props)=><ComCompanyinfo/>}/>
          
          <Route exact path='/recruiter/report' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/report' render={(props)=><Report/>}/>
          
          <Route exact path='/recruiter/report/:id' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/report/:id' render={(props)=><ReportSingle/>}/>

          <Route exact path='/recruiter/report/edit' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/report/edit' render={(props)=><ReportWrite/>}/>
          <Route exact path='/recruiter/report/edit/:id' render={(props)=><ComNav logout={handle_logout}/>}/>
          <Route exact path='/recruiter/report/edit/:id' render={(props)=><ReportWrite/>}/>

          {/* <Route exact path='/' component={Home}/>
          <Route exact path='/' component={Nav}/>
          
          <Route exact path='/' component={Home}/>
          <Route exact path='/' component={Nav}/> */}
          {/* <Modal
            isShowing={isShowing}
            hide={()=>setIsShowing(!isShowing)}
            logout={props.logout}
          /> */}

          <Route path="/login" component={LoginPage} />
          <Route path="/verifyingEmail" component={Verify}/>
          <Route path="/confirm" component={Confirm}/>
          </Router>
        :
        <HashRouter>

        </HashRouter>}

    </div>
    
  );
  
}

// export default App;

function mapState(state) {
  const { alert, users, authentication } = state;
  const { user } = authentication;
  return { user, users, alert };
}

const actionCreators = {
  getUsers: userActions.getUser,
  getAll: userActions.getAll,
  deleteUser: userActions.delete,
  clearAlerts: alertActions.clear,
  logout: userActions.logout
}

const connectedApp = connect(mapState, actionCreators)(App);
export {connectedApp as App};

// App.propTypes = {
//     logged_in: PropTypes.bool.isRequired,
//     // display_form: PropTypes.func.isRequired,
//     handle_logout: PropTypes.func.isRequired
// };

// import styled from 'styled-components';
